import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { SegmentsPage } from './-components/SegmentsPage';

function SegmentsRoute() {
  useSetBreadcrumbs([{ label: 'Workspace' }, { label: 'Segments' }]);
  return <SegmentsPage />;
}

export const Route = createFileRoute('/segments/')({
  component: SegmentsRoute,
  errorComponent: ErrorComponent,
});
